import { Component, signal, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { RoutingUtilService, stringToBoolean } from '@pflegix/util';
import { BusinessPartnerSidebarComponent } from '../business-partner-sidebar.component';

@Component({
  selector: 'pfx-business-partner-sidebar-container',
  imports: [BusinessPartnerSidebarComponent],
  templateUrl: './business-partner-sidebar-container.component.html',
})
export class BusinessPartnerSidebarContainerComponent {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);

  public businessPartnerId = signal('');

  public viewBusinessPartner = signal(false);

  constructor() {
    this.activatedRoute.queryParamMap.pipe(takeUntilDestroyed()).subscribe((params) => {
      this.businessPartnerId.set(params.get('sidebarBusinessPartnerId') ?? '');
      this.viewBusinessPartner.set(stringToBoolean(params.get('viewSidebarBusinessPartner') ?? ''));
    });
  }

  protected handleSidebarVisibleChanged(visible: boolean): void {
    if (visible) {
      return;
    }

    RoutingUtilService.removeQueryParams(this.router, this.activatedRoute, [
      'sidebarBusinessPartnerId',
      'viewSidebarBusinessPartner',
    ]);
  }
}
